export class Sc3ErrorMessageListCheck {
  public static readonly type = '[Sc3ErrorMessageList] Check';
  constructor(public payload: string) {}
}

export class Sc3ErrorMessageListInitialState {
  public static readonly type = '[Sc3ErrorMessageList] Set initial state';
}
